module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"limit":"Você já selecionou o número limite de fotos para este item. Avance para a próxima etapa."}}')
  delete Component.options._Ctor
}
